// extracted by mini-css-extract-plugin
module.exports = {"brands":"_3plim7","group":"_3JtjDs","letter":"_3_xKjk","link":"IBUyH5","shine-lines":"_21EyRr"};